module.exports = __webpack_public_path__ + "img/CarrotDown.1640e0fa.svg";